import { injectable } from "inversify-props";
import { find } from "@/api/analytics";
import { AnalyticsServiceAdapter } from "@/usecases";

@injectable()
export class AnalyticsService implements AnalyticsServiceAdapter {
	find = async (identificador: string, lojas: string[], isVendedor?: boolean) => await find(identificador, lojas, isVendedor)
}